import type { Sticker } from '../types';

export const dental: Sticker[] = [
  {
    id: 20001,
    url: 'https://stickers.nauczniaczek.pl/colections/14505663-dental-care/png/001-toothache.png',
    name: 'Ból Zęba',
    category: 'dental',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 20002,
    url: 'https://stickers.nauczniaczek.pl/colections/14505663-dental-care/png/002-mouthwash.png',
    name: 'Płyn do Płukania',
    category: 'dental',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 20003,
    url: 'https://stickers.nauczniaczek.pl/colections/14505663-dental-care/png/003-syringe.png',
    name: 'Strzykawka',
    category: 'dental',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 20004,
    url: 'https://stickers.nauczniaczek.pl/colections/14505663-dental-care/png/004-cavity.png',
    name: 'Próchnica',
    category: 'dental',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 20005,
    url: 'https://stickers.nauczniaczek.pl/colections/14505663-dental-care/png/005-dental care.png',
    name: 'Opieka Dentystyczna',
    category: 'dental',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 20006,
    url: 'https://stickers.nauczniaczek.pl/colections/14505663-dental-care/png/006-tongue cleaner.png',
    name: 'Skrobaczka do Języka',
    category: 'dental',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 20007,
    url: 'https://stickers.nauczniaczek.pl/colections/14505663-dental-care/png/007-dental care.png',
    name: 'Leczenie Zębów',
    category: 'dental',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 20008,
    url: 'https://stickers.nauczniaczek.pl/colections/14505663-dental-care/png/008-dental care.png',
    name: 'Higiena Jamy Ustnej',
    category: 'dental',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 20009,
    url: 'https://stickers.nauczniaczek.pl/colections/14505663-dental-care/png/009-toothbrush.png',
    name: 'Szczoteczka',
    category: 'dental',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 20010,
    url: 'https://stickers.nauczniaczek.pl/colections/14505663-dental-care/png/010-x rays.png',
    name: 'RTG Zębów',
    category: 'dental',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 20011,
    url: 'https://stickers.nauczniaczek.pl/colections/14505663-dental-care/png/011-dental care.png',
    name: 'Wizyta u Dentysty',
    category: 'dental',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 20012,
    url: 'https://stickers.nauczniaczek.pl/colections/14505663-dental-care/png/012-dental care.png',
    name: 'Gabinet Dentystyczny',
    category: 'dental',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 20013,
    url: 'https://stickers.nauczniaczek.pl/colections/14505663-dental-care/png/013-dental implant.png',
    name: 'Implant',
    category: 'dental',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 20014,
    url: 'https://stickers.nauczniaczek.pl/colections/14505663-dental-care/png/014-dental care.png',
    name: 'Zdrowe Zęby',
    category: 'dental',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 20015,
    url: 'https://stickers.nauczniaczek.pl/colections/14505663-dental-care/png/015-dental care.png',
    name: 'Dentysta',
    category: 'dental',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 20016,
    url: 'https://stickers.nauczniaczek.pl/colections/14505663-dental-care/png/016-x rays.png',
    name: 'Prześwietlenie',
    category: 'dental',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 20017,
    url: 'https://stickers.nauczniaczek.pl/colections/14505663-dental-care/png/017-dental floss.png',
    name: 'Nić Dentystyczna',
    category: 'dental',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 20018,
    url: 'https://stickers.nauczniaczek.pl/colections/14505663-dental-care/png/018-tooth extraction.png',
    name: 'Ekstrakcja Zęba',
    category: 'dental',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 20019,
    url: 'https://stickers.nauczniaczek.pl/colections/14505663-dental-care/png/019-dental care.png',
    name: 'Opieka Stomatologiczna',
    category: 'dental',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 20020,
    url: 'https://stickers.nauczniaczek.pl/colections/14505663-dental-care/png/020-brackets.png',
    name: 'Aparat na Zęby',
    category: 'dental',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  }
];